import { OptionStatus } from '../types/Option';
import { Option, SelectedOption } from '../__generated__/graphql';

export const getOptionStatusFromSelectedOption = (
  selectedOption: SelectedOption,
  option: Option,
) => {
  if (!selectedOption.desc || selectedOption.isAnswer == null) {
    return OptionStatus.NOT_CHOSEN;
  }
  if (selectedOption.desc.trim() !== option.desc.trim()) {
    // quick bug fix
    return option.isAnswer
      ? OptionStatus.NOT_CHOSEN_CORRECT
      : OptionStatus.NOT_CHOSEN;
  }
  return option.isAnswer
    ? OptionStatus.CHOSEN_CORRECT
    : OptionStatus.CHOSEN_INCORRECT;
};
